// Mock data for Mednosys.in — Authorized India Distributor for RehabVeda R1 & Stroke Insightz
// Plus Med-Tech advisory: SOC2 / IT security questionnaires + RFP & Sales Enablement

export const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Mission & Vision', to: '/mission-vision' },
  { label: 'Products', to: '/#products' },
  {
    label: 'Services',
    children: [
      { label: 'Medical AI IT / SOC2 Questionnaires', to: '/services/soc2-questionnaires' },
      { label: 'Xccelera — RFP & Sales Enablement', to: '/services/rfp-sales-enablement' },
    ],
  },
  { label: 'Contact', to: '/contact' },
];

export const HERO = {
  eyebrow: 'Authorized India Distributor · Med-Tech Advisory',
  titleLead: 'Bringing world-class',
  titleAccent: 'medical technology',
  titleMid: 'to Indian',
  titleAccent2: 'hospitals & homes.',
  subtitle:
    'Mednosys Enterprises is the authorized India distribution partner for RehabVeda R1 — the brain-controlled hand-rehab device — and Stroke Insightz, the AI perfusion suite from genzailabs.in. We also help Med-Tech startups win enterprise healthcare deals through SOC2 / IT security questionnaire response and RFP & sales enablement expertise.',
  primaryCta: 'Explore Our Products',
  secondaryCta: 'Request a Demo',
  stats: [
    { value: '2', label: 'Flagship products distributed' },
    { value: '1,000+', label: 'Patients recovered' },
    { value: '25+', label: 'Cities of presence' },
    { value: '10+', label: 'Hospital deployments' },
  ],
};

export const ABOUT = {
  eyebrow: 'About Mednosys',
  title: 'The distribution & go-to-market partner for India’s Med-Tech innovators.',
  body:
    'Mednosys Enterprises bridges the gap between breakthrough medical technology and the clinicians, hospitals and patients who need it. We are the authorized India distributor for RehabVeda R1 and Stroke Insightz — handling sales, rentals, installation, training and support. We also partner with early-stage Med-Tech startups on SOC2 / IT security questionnaire response and RFP-driven sales enablement.',
  pillars: [
    {
      icon: 'Handshake',
      title: 'Authorized Distributor',
      copy: 'Official India partner for RehabVeda R1 and Stroke Insightz.',
    },
    {
      icon: 'Truck',
      title: 'Sales & Rentals',
      copy: 'Flexible rental and purchase models so clinics and families can access the therapy that fits them.',
    },
    {
      icon: 'GraduationCap',
      title: 'Clinical Training',
      copy: 'Onboarding and hands-on training for physiotherapists, radiologists and hospital IT teams.',
    },
    {
      icon: 'ShieldCheck',
      title: 'Med-Tech Advisory',
      copy: 'SOC2 / IT questionnaires and RFP response expertise for Med-Tech startups scaling into enterprise healthcare.',
    },
  ],
};

export const VENTURES = [
  {
    id: 'rehabveda',
    tag: 'Neurotechnology · Device',
    name: 'RehabVeda R1',
    tagline: 'Brain-controlled hand rehabilitation for stroke & paralysis.',
    description:
      "India's first Motor-Imagery Brain-Computer Interface (MI-BCI). An EEG headband reads motor-imagery signals, an AI edge unit decodes them, and a smart pneumatic glove moves the hand — retraining cortico-muscular pathways through neuroplasticity. Clinically validated with published FMA and MAS outcomes.",
    highlights: [
      '1,000+ patients recovered across India',
      'CDSCO approved (Indian FDA) · non-invasive · drug-free',
      'MI-BCI for stroke, SCI, neuromuscular disorders',
      'Rental & purchase models via Mednosys',
    ],
    approvals: ['CDSCO Approved', 'Non-invasive', 'Peer-reviewed'],
    metrics: [
      { value: '60%', label: 'Reduction in spasticity' },
      { value: '₹499', label: 'Starter consultation' },
      { value: '13', label: 'Clinical parameters' },
    ],
    image:
      'https://images.unsplash.com/photo-1680783954745-3249be59e527?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxyb2JvdGljJTIwaGFuZHxlbnwwfHx8fDE3ODMyMzU3NjF8MA&ixlib=rb-4.1.0&q=85',
    link: 'https://rehabveda.ai',
    linkLabel: 'Product details',
  },
  {
    id: 'stroke-insightz',
    tag: 'AI Radiology · Software',
    name: 'Stroke Insightz™',
    tagline: 'AI-powered CT & MRI perfusion for acute stroke triage.',
    description:
      'Comprehensive AI stroke suite from genzailabs.in. Delivers ASPECTS scoring, core/penumbra maps, Net Water Uptake analysis, tumor perfusion (nCBV/PSR/K2), and structured stroke reports — in under 30 seconds — directly inside hospital PACS via DICOM-compatible workflows.',
    highlights: [
      'PACS-integrated · DICOM-compatible',
      'On-premise or cloud deployment',
      'CT perfusion, MRI DSC, MRI ASL, TB screening',
      'India sales & deployment via Mednosys',
    ],
    approvals: ['Peer-reviewed', 'Patent-filed', 'HIPAA-aligned'],
    metrics: [
      { value: '<30s', label: 'Analysis time' },
      { value: '~5 min', label: 'Full stroke report' },
      { value: '5', label: 'AI modules available' },
    ],
    image:
      'https://images.unsplash.com/photo-1666214280250-41f16ba24a26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxBSSUyMG1lZGljYWwlMjBpbWFnaW5nfGVufDB8fHx8MTc4MzIzNTc2MXww&ixlib=rb-4.1.0&q=85',
    link: 'https://genzailabs.in',
    linkLabel: 'Product details',
  },
];

export const INNOVATION = {
  eyebrow: 'Why Mednosys',
  title: 'More than a distributor — your clinical deployment partner.',
  cards: [
    {
      step: '01',
      title: 'Consultation & Demo',
      copy: 'On-site or online demos for hospitals, rehab centres and individual patients across India.',
    },
    {
      step: '02',
      title: 'Purchase or Rental',
      copy: 'Flexible models — monthly rentals for families, capex purchases for hospitals — with GST-compliant invoicing.',
    },
    {
      step: '03',
      title: 'Installation & Training',
      copy: 'Technicians handle physical setup, PACS integration and hands-on training for clinicians.',
    },
    {
      step: '04',
      title: 'Clinical Support',
      copy: 'Dedicated support team for troubleshooting, therapy monitoring and software upgrades.',
    },
  ],
};

export const IMPACT_STATS = [
  { value: '1,000+', label: 'Lives touched through therapy', sub: 'RehabVeda R1 patients across India' },
  { value: '5 min', label: 'Complete stroke perfusion report', sub: 'Stroke Insightz clinical workflow' },
  { value: '10+', label: 'Hospital deployments', sub: 'Partner clinics & imaging centres' },
  { value: '25+', label: 'Cities served', sub: 'Pan-India distribution reach' },
];

export const NEWS = [
  {
    date: 'Nov 2025',
    tag: 'Deployment',
    title: 'Stroke Insightz goes live at a Pune partner hospital.',
    excerpt: 'Mednosys completes PACS integration, DICOM workflow setup and radiologist onboarding for the AI perfusion suite.',
    image:
      'https://images.unsplash.com/photo-1766297247924-6638d54e7c89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxtZWRpY2FsJTIwdGVjaG5vbG9neSUyMGxhYnxlbnwwfHx8fDE3ODMyMzU3Njd8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    date: 'Oct 2025',
    tag: 'Milestone',
    title: 'RehabVeda R1 crosses 1,000 patients treated across India.',
    excerpt: 'Mednosys distribution network expands hand-rehab access to 25+ cities pan-India through rental and purchase models.',
    image:
      'https://images.unsplash.com/photo-1666886573212-2de95596d509?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxkb2N0b3IlMjB0YWJsZXR8ZW58MHx8fHwxNzgzMjM1NzYxfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    date: 'Sept 2025',
    tag: 'Advisory',
    title: 'Mednosys launches Med-Tech RFP & SOC2 advisory practice.',
    excerpt: 'A dedicated team helps early-stage Med-Tech startups respond to enterprise IT security questionnaires and hospital RFPs.',
    image:
      'https://images.unsplash.com/photo-1719550371336-7bb64b5cacfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxicmFpbiUyMG5ldXJhbCUyMG5ldHdvcmt8ZW58MHx8fHwxNzgzMjM1NzYxfDA&ixlib=rb-4.1.0&q=85',
  },
];

// Removed all third-party company mentions (Nexactly AI, DPU FIIIE, GenzAI Labs corp entity)
// as per requirement — only the two products (RehabVeda R1, Stroke Insightz) remain.
export const PARTNERS = [
  'Deenanath Mangeshkar Hospital',
  'DY Patil Super Specialty Hospital',
  'Noble Hospital, Pune',
];

export const MISSION_VISION = {
  hero: {
    eyebrow: 'Mission & Vision',
    title: 'Making world-class medical technology accessible — one hospital, one home, one recovery at a time.',
    subtitle:
      'India needs Med-Tech that is not only clinically excellent but also affordable, distributable and supportable. That is our purpose.',
  },
  mission: {
    heading: 'Our Mission',
    body:
      'To bridge the last mile between advanced medical technology and the clinicians, hospitals and patients across India who need it. We do this by distributing clinically-validated products — RehabVeda R1 and Stroke Insightz — with genuine sales, training and after-sales support, and by advising Med-Tech startups on the enterprise readiness required to scale.',
    points: [
      'Expand access to brain-controlled rehabilitation therapy in every Indian city.',
      'Accelerate acute stroke care through AI-driven perfusion imaging in hospital workflows.',
      'Empower Med-Tech startups to clear the enterprise IT, SOC2 and RFP bar so they can win hospital deals.',
      'Build long-term clinical partnerships anchored in outcomes, not one-off transactions.',
    ],
  },
  vision: {
    heading: 'Our Vision',
    body:
      'A future where every Indian stroke survivor has access to neurotechnology-driven hand recovery, every acute stroke case is triaged by AI in under five minutes, and every deep-tech Med-Tech startup can compete for enterprise contracts with a mature go-to-market spine.',
    points: [
      'Nation-wide neuro-rehab access through rental & clinic partnerships.',
      'AI decision support in every stroke-ready hospital PACS.',
      'A trusted advisory home for Med-Tech go-to-market in India.',
    ],
  },
  values: [
    { title: 'Evidence First', copy: 'We only distribute what is clinically validated and published in peer-reviewed literature.' },
    { title: 'Access Over Hype', copy: 'Rental models, transparent pricing and pan-India logistics — not glossy marketing.' },
    { title: 'Clinician Partnership', copy: 'We embed with radiologists and physiotherapists to build workflow-realistic solutions.' },
    { title: 'Long-Term Support', copy: 'A product installed is a relationship begun — training, upgrades and support are non-negotiable.' },
  ],
};

export const SOC2 = {
  hero: {
    eyebrow: 'Medical AI IT / SOC2 Questionnaire Expertise',
    title: 'Clear the enterprise IT security bar. Faster.',
    subtitle:
      'Every hospital purchase decision passes through the CIO, InfoSec and Compliance desks. We help Medical-AI and Med-Tech startups respond to SOC2, HIPAA, HITRUST, ISO 27001, DPDPA and hospital-specific IT questionnaires — accurately, defensibly and in days, not months.',
  },
  offerings: [
    {
      title: 'SOC2 Type I & Type II questionnaire response',
      copy: 'End-to-end drafting of vendor security assessments (VSA), SIG, CAIQ, and hospital-custom questionnaires with evidence mapping.',
    },
    {
      title: 'HIPAA / DPDPA / GDPR readiness reviews',
      copy: 'Data-flow mapping, PHI classification, BAA readiness, DPDPA (India) alignment, and cross-border transfer documentation.',
    },
    {
      title: 'DICOM / PACS integration security',
      copy: 'Modality worklist, DICOM TLS, PACS routing, audit logs, and imaging data-lifecycle controls tailored to radiology AI.',
    },
    {
      title: 'AI / ML model governance',
      copy: 'Model cards, training-data provenance, drift monitoring, human-in-the-loop policies — aligned to FDA / CDSCO guidance.',
    },
    {
      title: 'Encryption & access controls',
      copy: 'AES-256 at rest, TLS 1.3 in transit, RBAC, SSO/SAML, MFA, key management, and inference audit-log documentation.',
    },
    {
      title: 'On-prem vs cloud deployment posture',
      copy: 'Deployment architecture diagrams and control mappings for hospital on-prem, hybrid, and cloud-hosted variants.',
    },
  ],
  process: [
    { step: '01', title: 'Scoping call', copy: 'Understand your product, buyer profile, and questionnaire backlog.' },
    { step: '02', title: 'Evidence collection', copy: 'Map existing policies, architecture and controls to questionnaire clauses.' },
    { step: '03', title: 'Drafting & review', copy: 'Answers drafted by security-fluent writers, reviewed by product & compliance leads.' },
    { step: '04', title: 'Turnaround & handover', copy: 'Standard 5–10 business day turnaround with a reusable answer library for your team.' },
  ],
  outcomes: [
    'Faster hospital sales cycles — InfoSec approvals unblocked.',
    'A reusable, defensible answer library for future RFPs.',
    'Reduced compliance risk in DPDPA / HIPAA-adjacent deployments.',
    'InfoSec-ready product architecture documentation.',
  ],
};

export const RFP = {
  brand: 'Xccelera',
  brandTagline: 'The Mednosys bid-desk practice for Med-Tech startups.',
  hero: {
    eyebrow: 'Xccelera · RFP Response & Sales Enablement · Healthcare',
    title: 'Xccelera — win hospital & enterprise deals with RFP responses that actually convert.',
    subtitle:
      'Xccelera is the Mednosys practice for healthcare RFPs. Hospital, payer and government tenders in Med-Tech are dense, technical and outcome-driven. We build RFP response engines and sales-enablement collateral tailored to Med-Tech startups — combining clinical evidence, IT / SOC2 posture, commercials and deployment plans into a single, credible narrative.',
  },
  offerings: [
    {
      title: 'RFP / RFI / EOI response',
      copy: 'End-to-end response drafting for hospital, government, insurance and enterprise RFPs. Structure, technical narrative, compliance annexes and pricing tables.',
    },
    {
      title: 'Sales-enablement collateral',
      copy: 'Clinical decks, one-pagers, ROI calculators, case-study kits, demo scripts and objection-handling playbooks for AEs and clinical liaisons.',
    },
    {
      title: 'Pricing & commercial modelling',
      copy: 'Per-scan, per-bed, subscription, rental, capex and pilot-to-paid pricing models with GST-compliant Indian invoicing.',
    },
    {
      title: 'Clinical evidence packaging',
      copy: 'Peer-reviewed study summaries, retrospective validation data, patent references and safety notes translated for procurement teams.',
    },
    {
      title: 'PACS / EMR integration statements',
      copy: 'Standard integration write-ups (DICOM, HL7, FHIR, PACS vendors) that pass technical evaluation the first time.',
    },
    {
      title: 'Ongoing bid-desk retainer',
      copy: 'Monthly retainer coverage — continuous RFP response, sales collateral updates, and questionnaire refresh as your product evolves.',
    },
  ],
  process: [
    { step: '01', title: 'Pipeline review', copy: 'Assess active RFPs, win-themes and buyer personas.' },
    { step: '02', title: 'Response architecture', copy: 'Design a repeatable response template mapped to clinical + IT + commercial sections.' },
    { step: '03', title: 'Drafting & polish', copy: 'Bid-desk drafts, clinical review, and executive-grade polish before submission.' },
    { step: '04', title: 'Win-loss review', copy: 'Post-submission debrief with the buyer where possible — feeding lessons into the next bid.' },
  ],
  sample: {
    title: 'What an Xccelera RFP response looks like',
    sections: [
      'Executive summary & clinical value proposition',
      'Product technical specifications & AI methodology',
      'Clinical evidence, publications & regulatory posture',
      'IT security, SOC2 / HIPAA / DPDPA compliance annex',
      'Deployment plan — on-prem / cloud / hybrid',
      'Training, support and SLAs',
      'Commercial models & TCO analysis',
      'References & case studies',
    ],
  },
  outcomes: [
    'Higher win rates on hospital & enterprise RFPs.',
    'Sales cycles shortened through pre-answered IT / clinical questions.',
    'A repeatable RFP playbook owned by your commercial team.',
    'Clinical evidence framed in procurement-friendly language.',
  ],
};

export const CONTACT_PEOPLE = [
  {
    name: 'Priyam Srivastav',
    role: 'Sales & Distribution Partner — Head',
    territory: 'Karnataka · Kerala · Tamil Nadu',
    phone: '+91 99405 38600',
    domain: 'RehabVeda R1 · Stroke Insightz — South India',
    initials: 'PS',
  },
  {
    name: 'Murali Krishna Sagi',
    role: 'Sales Manager — Head',
    territory: 'Andhra Pradesh · Telangana',
    phone: '+91 89777 73547',
    domain: 'RehabVeda R1 · Stroke Insightz — AP / Telangana',
    initials: 'MK',
  },
  {
    name: 'Manjari Manisha',
    role: 'Head — Xccelera (RFP & Sales Enablement Practice)',
    territory: 'Pan-India · Med-Tech advisory',
    phone: 'On request',
    domain: 'Xccelera: RFP response · SOC2 questionnaires · Sales collateral',
    initials: 'MM',
  },
];

export const CONTACT = {
  addressIN: 'Mednosys Enterprises, India — Pan-India sales & service.',
  phones: ['+91 99405 38600 (Karnataka / Kerala / TN)', '+91 89777 73547 (AP / Telangana)'],
  email: 'sales@mednosys.in',
};
